__turbopack_context__.v({
  "buttonText": "BulkActionsBar-module__xXoS1W__buttonText",
  "buttonsWrapper": "BulkActionsBar-module__xXoS1W__buttonsWrapper",
  "closeButton": "BulkActionsBar-module__xXoS1W__closeButton",
  "fixedBar": "BulkActionsBar-module__xXoS1W__fixedBar",
  "root": "BulkActionsBar-module__xXoS1W__root",
  "selectedCount": "BulkActionsBar-module__xXoS1W__selectedCount",
});
